import styled from '@emotion/styled'

import { getHeaderCellStyles } from '../../../../../utils/getHeaderCellStyles'

export const HeaderCell = styled.th`
  ${getHeaderCellStyles()}
`
